const pad = (n) => String(n).padStart(2, '0');

export const generateEtaTimeOptions = (startAt, endAt, intervalMinutes = 15) => {
    if (!startAt || !endAt) return [];

    const start = new Date(startAt);
    const end = new Date(endAt);

    const current = new Date();
    current.setHours(start.getHours(), start.getMinutes(), 0, 0);
    current.setMinutes(Math.ceil(current.getMinutes() / intervalMinutes) * intervalMinutes);

    const endTime = new Date();
    endTime.setHours(end.getHours(), end.getMinutes(), 0, 0);

    const options = [];

    while (current <= endTime) {
        const value = `${pad(current.getHours())}:${pad(current.getMinutes())}`;
        options.push({
            value,
            label: current.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' }),
        });
        current.setMinutes(current.getMinutes() + intervalMinutes);
    }

    return options;
};

export const isValidEtaTime = (etaTime, startAt, endAt, intervalMinutes = 15) => {
    if (!etaTime) return false;
    return generateEtaTimeOptions(startAt, endAt, intervalMinutes).some(option => option.value === etaTime);
};
